import axios from 'axios';

export const fetchStates = async (countryCode) => {
  try {
    const response = await axios.get(
      `${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}wp-json/beaver_next_wordpress/v1/states`,
      { params: { cc: countryCode } },
    );
    return response.data || {};
  } catch (error) {
    console.error("Error fetching states:", error);
    return {};
  }
};

export const fetchCities = async (countryCode) => {
  try {
    const response = await axios.get(
      `${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}wp-json/beaver-next-shipping-area/v1/cities`,
      { params: { cc: countryCode } },
    );
    return response.data || [];
  } catch (error) {
    console.error("Error fetching cities:", error);
    return [];
  }
};

export const fetchStreets = async (cityId) => {
  try {
    const response = await axios.get(
      `${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}wp-json/beaver-next-shipping-area/v1/streets/${cityId}`,
    );

    return response.data || [];
  } catch (error) {
    console.error("Error fetching streets:", error);
    return [];
  }
};